import type { ReactNode } from "react";

/**
 * 課金画面の横棒の色 (使用量グラフはカテゴリの系列色を使う)。セグメントは色で塗り分けず、BarTrack の隙間で区切る。
 * セグメントの同定はツールチップが担う。
 */
export const BAR_COLOR = "var(--accent-line)";

/** 消費が僅少でもバー・セグメントが見えて hover できるよう保証する最小幅 (px)。 */
export const MIN_BAR_SEGMENT_WIDTH = 10;

/** バーの下地トラック。子のセグメント間には視認用に 2px の隙間を空ける。 */
export function BarTrack({ children }: { children: ReactNode }) {
	return (
		<div
			style={{
				width: "100%",
				height: 6,
				borderRadius: "var(--radius-full)",
				background: "var(--surface-2)",
				overflow: "hidden",
				display: "flex",
				gap: 2,
			}}
		>
			{children}
		</div>
	);
}
